import React, { useEffect, useState } from 'react';
import { MonacoEditor } from './MonacoEditor';
import { quicktypeJSONSchema } from '../../../util/quicktype';
import { CopyJSONSchema } from './CopyJSONSchema';

export default function JSONSchemaDisplayer({
  jsonSchema,
  jsonSchemaTypeName: typeName,
  schemaLanguage,
}) {
  const [data, setData] = useState([]);
  const [text, setText] = useState(JSON.stringify(jsonSchema, null, 2));

  useEffect(() => {
    if (schemaLanguage !== 'json') {
      quicktypeJSONSchema({
        targetLanguage: schemaLanguage,
        typeName: typeName || 'JsonSchemaType',
        jsonSchemaString: JSON.stringify(jsonSchema),
      }).then((result) => {
        setData(result.lines);
        setText(result.lines.join('\n'));
      });
    } else {
      setData([]);
      setText(JSON.stringify(jsonSchema, null, 2));
    }
  }, [schemaLanguage, jsonSchema]);

  return (
    <div>
      <CopyJSONSchema
        schemaLanguage={schemaLanguage}
        textToCopy={text}
      />
      <div>
        {text?.length > 0 && (
          <MonacoEditor language={schemaLanguage} text={text} />
        )}
      </div>
    </div>
  );
}
